export default "__VITE_ASSET__DjqgH5Iq__"